import { render, staticRenderFns } from "./showList.vue?vue&type=template&id=b37edc46&scoped=true"
import script from "./showList.vue?vue&type=script&lang=js"
export * from "./showList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37edc46",
  null
  
)

export default component.exports